import React from 'react';

function UpDownArrowIcon({direction = 'asc'}) {
  return (direction === 'asc'
    ? (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 15 15" enableBackground="new 0 0 15 15">
        <path fill="#404040" d="M12.7,10.3L12.7,10.3c0.2-0.2,0.2-0.6,0-0.8L8.2,4.8 c-0.4-0.4-1.1-0.4-1.5,0L2.2,9.5c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0L7.1,6c0.2-0.2,0.6-0.2,0.8,0l4.1,4.3 C12.2,10.5,12.5,10.5,12.7,10.3"/>
      </svg>
    ) : (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 15 15" enableBackground="new 0 0 15 15">
        <path fill="#404040" d="M2.2,4.7L2.2,4.7c-0.2,0.2-0.2,0.6,0,0.8l4.5,4.7 c0.4,0.4,1.1,0.4,1.5,0l4.5-4.7c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0L7.8,9C7.6,9.2,7.3,9.2,7.1,9L2.9,4.7 C2.7,4.5,2.4,4.5,2.2,4.7"/>
      </svg>
    )
  )
}

export default UpDownArrowIcon;



// WEBPACK FOOTER //
// ./src/components/icons/UpDownArrowIcon.js